export const PRICING_PLANS = [
  {
    id: "starter",
    name: "Starter",
    price: 4999,
    currency: "INR",
    period: "one-time",
    description: "Perfect for students starting their study-abroad journey.",
    features: [
      "Free profile assessment",
      "University shortlisting (up to 5)",
      "Document checklist & review",
      "Email support for 30 days",
    ],
    popular: false,
    service: "consultation",
  },
  {
    id: "premium",
    name: "Premium",
    price: 14999,
    currency: "INR",
    period: "one-time",
    description: "Our most popular package for complete admission support.",
    features: [
      "Everything in Starter",
      "Full application assistance (3 universities)",
      "SOP & LOR guidance",
      "Visa document preparation",
      "Dedicated counsellor",
      "Priority support for 90 days",
    ],
    popular: true,
    service: "admission",
  },
  {
    id: "elite",
    name: "Elite",
    price: 29999,
    currency: "INR",
    period: "one-time",
    description: "End-to-end support from application to departure.",
    features: [
      "Everything in Premium",
      "Unlimited university applications",
      "Professional SOP writing included",
      "Visa filing & interview prep",
      "Accommodation assistance",
      "Air ticket booking support",
      "Pre-departure briefing",
      "6-month post-enrollment support",
    ],
    popular: false,
    service: "full-service",
  },
];

export const ADD_ON_SERVICES = [
  {
    id: "sop-writing",
    name: "SOP Writing",
    price: 3999,
    currency: "INR",
    description: "Professional Statement of Purpose crafted by expert writers.",
    route: "/resume",
  },
  {
    id: "visa-assistance",
    name: "Visa Assistance",
    price: 7999,
    currency: "INR",
    description: "Complete student visa filing with interview preparation.",
    route: "/visa",
  },
  {
    id: "ielts-coaching",
    name: "IELTS Coaching",
    price: 9999,
    currency: "INR",
    description: "8-week intensive IELTS preparation with mock tests.",
    route: "/services",
  },
  {
    id: "accommodation",
    name: "Accommodation Booking",
    price: 2499,
    currency: "INR",
    description: "Safe, verified student housing near your university.",
    route: "/accomodation",
  },
  {
    id: "air-tickets",
    name: "Air Ticket Booking",
    price: 999,
    currency: "INR",
    description: "Service fee for best-deal student flight bookings.",
    route: "/air",
  },
  {
    id: "sim-card",
    name: "International SIM",
    price: 1499,
    currency: "INR",
    description: "Pre-activated SIM delivered before you land abroad.",
    route: "/sim",
  },
];

export const formatPrice = (amount, currency = "INR") => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
};
